import $ from 'jquery'
async function carregaUrl () {
    await $.getJSON("web.json", function(data) {
        localStorage.setItem('APIPagamentos', data.baseURLPagamento)
    })
}
carregaUrl()